import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzTypographyModule } from 'ng-zorro-antd/typography';

import { DialogConfirmPromptModule } from '@libs/src/dialog-confirm-prompt/dialog-confirm-prompt.module';
import { ListValuesDialogModule } from '@libs/src/list-values-dialog/list-values-dialog.module';
import { CsvAttributeTranslationNamePipeModule } from '@main-client/src/app/pipes/csv-attribute-translation-name-pipe/csv-attribute-translation-name-pipe.module';
import { MakeSortStringFnPipeModule } from '@main-client/src/app/pipes/make-sort-string-fn/make-sort-string-fn-pipe.module';

import { DialogConfirmPromptService } from '@libs/src/dialog-confirm-prompt/dialog-confirm-prompt.service';
import { ListValuesDialogService } from '@libs/src/list-values-dialog/list-values-dialog.service';

import { CsvAttributeMappingsComponent } from './csv-attribute-mappings.component';

import { PopulateSegmentValuesDrawerModule } from '../../automated-user-management/populate-segment-values-drawer/populate-segment-values-drawer.module';
import { AttributeMappingDrawerModule } from '../attribute-mapping-drawer/attribute-mapping-drawer.module';

@NgModule({
  declarations: [CsvAttributeMappingsComponent],
  exports: [CsvAttributeMappingsComponent],
  imports: [
    AttributeMappingDrawerModule,
    CommonModule,
    CsvAttributeTranslationNamePipeModule,
    DialogConfirmPromptModule,
    FlexLayoutModule,
    FormsModule,
    ListValuesDialogModule,
    MakeSortStringFnPipeModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    NzCheckboxModule,
    NzSelectModule,
    NzTableModule,
    NzToolTipModule,
    NzTypographyModule,
    PopulateSegmentValuesDrawerModule,
  ],
  providers: [DialogConfirmPromptService, ListValuesDialogService],
})
export class CsvAttributeMappingsModule {}
